import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";

export default function TopNav() {
  const { user, platformRole, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isDash = location.pathname.startsWith("/dashboard") || location.pathname.startsWith("/admin");
  const isAdmin = platformRole === "admin" || platformRole === "staff";

  return (
    <header className="fx-glass-nav sticky top-0 z-40 w-full" data-testid="top-nav">
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-4 sm:px-6 lg:px-10 h-16 gap-3">
        <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="brand-logo">
          <img src="/agenaix/logo-primary.svg" alt="Agenaix" className="h-5 sm:h-6 w-auto" />
        </Link>

        {!isDash && (
          <nav className="hidden md:flex items-center gap-8 fx-mono-tag">
            <a href="/#about" className="hover:text-[#0B1F3A] transition-colors" data-testid="nav-about">ABOUT</a>
            <a href="/#services" className="hover:text-[#0B1F3A] transition-colors" data-testid="nav-services">SERVICES</a>
            <a href="/#portfolio" className="hover:text-[#0B1F3A] transition-colors" data-testid="nav-portfolio">WORK</a>
            <a href="/#approach" className="hover:text-[#0B1F3A] transition-colors" data-testid="nav-approach">APPROACH</a>
            <a href="/#contact" className="hover:text-[#0B1F3A] transition-colors" data-testid="nav-contact">CONTACT</a>
          </nav>
        )}

        <div className="flex items-center gap-2 sm:gap-3">
          {user ? (
            <>
              {isAdmin ? (
                <Button size="sm" variant="outline" onClick={() => navigate("/admin")} data-testid="nav-admin-btn" className="rounded-md h-9 px-3 text-xs sm:text-sm border-[#DCE3ED]">Admin</Button>
              ) : (
                <Button size="sm" variant="outline" onClick={() => navigate("/dashboard")} data-testid="nav-dashboard-btn" className="rounded-md h-9 px-3 text-xs sm:text-sm border-[#DCE3ED]">Dashboard</Button>
              )}
              <Button size="sm" onClick={async () => { await signOut(); navigate("/"); }} className="fx-btn-primary rounded-md h-9 px-3 text-xs sm:text-sm" data-testid="nav-logout-btn">Log out</Button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm font-medium text-[#172033] hover:text-[#0B4DCC] transition-colors px-2" data-testid="nav-login-link">Log in</Link>
              <Button size="sm" onClick={() => navigate("/signup")} className="fx-btn-primary rounded-md h-9 px-3 sm:px-4 text-xs sm:text-sm" data-testid="nav-signup-btn">
                <span className="hidden sm:inline">Launch status →</span>
                <span className="sm:hidden">Status</span>
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
